module.exports = __webpack_public_path__ + "static/sunkissed-regular-webfont-4c8c370cc9500611e8debf895c7c2cdd.woff";